import React from 'react'
import { css } from '@emotion/core'
import { LanguageSelect } from '@/components/molecules/front-tablet/language-select'
import {
  createSelfCheckinBaseStyle,
  createSelfCheckinResponsiveStyle,
  FrontTabletResponsiveToken,
} from '@/utils/front-tablet-responsive-style'

export type HeaderProps = {
  title: string
  goToPreviousPage?: () => void
}

export const HeaderHeight = 80
export const Header: React.FC<HeaderProps> = ({ title, goToPreviousPage }) => {
  return (
    <div css={headerStyle}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        {goToPreviousPage ? (
          <div className="prev-icon">
            <img src={require('@/static/images/arrow_left_yellow.svg')} onClick={goToPreviousPage} />
          </div>
        ) : (
          <div className="no-prev-icon" />
        )}
        <div className="header-title">{title}</div>
      </div>
      <div className="language-select">
        <LanguageSelect />
      </div>
    </div>
  )
}

const headerStyle = css(
  {
    width: '100%',
    height: HeaderHeight,
    fontSize: 24,
    fontWeight: 'bold',
    letterSpacing: '1.8px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    boxShadow: '0px 2px 3px #00000014',
    backgroundColor: '#fff',
    position: 'fixed',
    zIndex: 5,
    '.prev-icon': {
      height: 80,
      width: 80,
      cursor: 'pointer',
      img: { width: '100%', height: '100%' },
    },
    '.language-select': { paddingRight: 24 },
    '.header-title': {
      lineHeight: '33px',
      letterSpacing: '1.2px',
    },
    '.no-prev-icon': {
      width: 30,
      height: 80,
    },
  },
  createSelfCheckinBaseStyle({ top: 0, left: 0 }),
  createSelfCheckinResponsiveStyle({
    landscape13: {
      height: FrontTabletResponsiveToken.headerHeight.landscape13,
      fontSize: 28,
      '.header-title': {
        lineHeight: '39px',
        letterSpacing: '1.4px',
      },
      '.prev-icon': {
        width: 80,
        height: 80,
      },
    },
  }),
)
